import React from "react";
import { Link } from "react-router-dom";
import "./History.css";

function History() {
  const timeEraList = [
    { grade: 1, title: "Dawn of Humanity", path: "Prehistoric" },
    { grade: 2, title: "Ancient Civilizations", path: "AncientEgypt" },
    { grade: 3, title: "World Cultures & Myths", path: "AncientGreeceRome" },
    { grade: 4, title: "Empires & Exploration", path: "Medieval" },
    { grade: 5, title: "Revolutions & Discovery", path: "Renaissance" },
    { grade: 6, title: "Industrial Age & Empires", path: "IndustrialRevolution" },
    { grade: 7, title: "World Wars Era", path: "WorldWars" },
    { grade: 8, title: "The 20th Century", path: "ColdWar" },
    { grade: 9, title: "Canada & the World", path: "ModernWorld" },
    { grade: 10, title: "Colonialism & Resistance", path: "Future" },

  ];

  return (
    <div className="play2learn-History">
      <h1 className="History-title">History Adventure</h1>
      <p className="History-description">
        Travel through time and discover the world’s greatest moments in human history!
      </p>

      <div className="History-grade-container">
        {timeEraList.map((era, index) => (
          <Link key={index} to={`/eras/${era.path}`} className="History-grade-card">
            Grade {era.grade}: {era.title}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default History;
